<template>
  <v-list nav dense>
    <template>
      <v-list-item link router to="/home" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('inicio') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-dumbbell" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t('gym') || 'Gimnasio' }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/gym" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Mis socios y asignaciones
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/admin/coach-routines" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-clipboard-list</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Mis rutinas
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item link router to="/settings" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-cog-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('configuracion') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('Ayuda') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'coach'
}
</script>

<style scoped>
.list:hover {
  background: white;
  opacity: 0.85;
}
</style>
